import React from 'react';
import { OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { ICustomizableElement, ITestingElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { ContentCardStyled } from './styles';

interface ContentCardProps extends ICustomizableElement, ITestingElement {
  children: React.ReactNode;
  loading?: boolean;
  minHeight?: string;
}

/*
 * A styled container component with a white rounded background.
 */
const ContentCard: React.FC<ContentCardProps> = ({
  children,
  loading,
  className,
  minHeight = '',
  'data-test-id': dataTestId,
}) => {
  return (
    <ContentCardStyled $minHeight={minHeight} className={className} data-test-id={dataTestId}>
      {loading ? <OverlaySpinner display overlay="none" /> : <>{children}</>}
    </ContentCardStyled>
  );
};

export default ContentCard;
